import PropTypes from 'prop-types';
import { Row, Col, FormGroup, Label, Input } from 'twyne-new.ui';

const propTypes = {
  match: PropTypes.object,
}

export default function FluentForm({ data, onChange, disabled }) {
  return <Row>
    <Col size="6">
      <FormGroup>
        <Label>Partner Id</Label>
        <Input type="text" disabled={disabled} value={data.partnerId || ''}
          onChange={e => onChange('partnerId', e.target.value)} required />
      </FormGroup>
    </Col>
  </Row>
}

FluentForm.propTypes = propTypes
FluentForm.defaultProps = {}
